export const LocalStorageKeys = {
	GAME: "GAME",
	POSTLOGINURL: "POSTLOGINURL",
	POSTLINKURL: "POSTLINKURL",
	STAY_ON_LEGACY: "stayOnLegacy",
};

export const SessionStorageKeys = {
	GAME: "GAME",
	EVENTID: "EVENTID",
	GROUPPICKS: "GROUPPICKS",
	MATCHPICKS: "MATCHPICKS",
};
